import OverlayScrollbarsStatic from 'overlayscrollbars';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { App, AppProvider } from 'components/app';
import { logWebVitals, reportWebVitals } from 'lib/performance';
import 'overlayscrollbars/css/OverlayScrollbars.css';

// Configure default options for all scrollbars
OverlayScrollbarsStatic.defaultOptions({
  ...OverlayScrollbarsStatic.defaultOptions(),
  scrollbars: {
    autoHide: 'move',
    autoHideDelay: 2000,
    clickScrolling: true,
  },
});

ReactDOM.render(
  <StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  </StrictMode>,
  document.getElementById('root'),
);

// Start reporting web vitals
reportWebVitals(logWebVitals);
